
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/harta-site",
      function () {
        return require("private-next-pages/harta-site.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/harta-site"])
      });
    }
  